import { produce } from 'immer';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface MessageItem {
  url: string;
  message: string;
}

interface MessageState {
  messages: MessageItem[];
}

interface MessageAction {
  updateMessage: (message: MessageItem) => void;
  getCurrentMessage: (url: string) => MessageItem;
  clearMessage: (url: string) => void;
  clearAll: () => void;
}

const initialState: MessageState = {
  messages: [],
};

const useMessageStore = create<MessageState & MessageAction>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        updateMessage(update) {
          set(
            produce((draft: MessageState) => {
              const isNotEqualArray = draft.messages.filter((message) => message.url !== update.url);

              if (isNotEqualArray.length === draft.messages.length) {
                // 값이 동일하면, 존재하지않은 채널이므로 추가
                draft.messages = [...draft.messages, update];
              } else {
                // 값이 동일하지않으면, 같은 채널 존재 -> 같은 채널 제거 후 추가
                draft.messages = [...isNotEqualArray, update];
              }
            }),
          );
        },
        getCurrentMessage(url) {
          return get().messages.filter((message) => message.url === url)[0];
        },
        clearMessage(url) {
          set(
            produce((draft: MessageState) => {
              draft.messages = draft.messages.filter((message) => message.url !== url);
            }),
          );
        },
        clearAll() {
          set(initialState);
        },
      }),
      { name: 'CHANNEL_MESSAGE_KEY' },
    ),
  ),
);

export default useMessageStore;
